import { JiraIntegrationForm } from '../../jira-integration-page/jira-form-schema'

export const mockJiraBugtracker: JiraIntegrationForm = {
  name: 'oSNG9ETbWMk2DJOeLpJT70EE',
  credentials_id: '6fa960d5-ec0c-468b-b89a-0346e9d8fb12',
  applications: [],
  all_applications: true,
  importance: [],
  app_criterion: true,
  auto_create_tickets_enabled: false,
  auto_create_tickets_severities: [],
  auto_create_tickets_rules: [],
  project: {
    id: '11940',
    key: 'test',
    name: 'test project'
  },
  assignee: {
    displayName: 'Unassigned',
    active: true,
    timeZone: '',
    locale: '',
    accountId: '-1',
    key: '-1',
    emailAddress: '',
    name: ''
  },
  issue_type: {
    id: 1,
    name: 'Task',
    icon_url: 'testurl.jpg'
  },
  priority_field_available: true,
  priority_critical: 'Critical',
  priority_high: 'Critical',
  priority_medium: 'Major',
  priority_low: 'Standard',
  priority_note: 'Critical',
  epic_id: null,
  fields: [
    {
      key: 'components',
      type: 'array',
      items: 'component',
      value: '.NET Core'
    },
    {
      key: 'customfield_13264',
      type: 'multiselect',
      items: 'option',
      value: 'Platform'
    },
    {
      key: 'reporter',
      type: 'user',
      items: null,
      value: '60ca3fafb1f93b0069244a13'
    },
    {
      key: 'customfield_13224',
      type: 'multiselect',
      items: 'option',
      value: 'Support'
    }
  ],
  serverless: false,
  serverless_account_ids: [],
  serverless_categories: [],
  integration: false,
  exclude_sensitive_info: false,
  integrations: [],
  send_tags: false
}
